import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Post, PostManagementLevel, PostPriority, PostStatus, PostType } from '@eview/core/domain/post/post';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import { EGetAlertsActions } from '@eview/core/store/actions/get-alerts.actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'eview-slider-select',
  templateUrl: 'slider-select.component.html',
  styleUrls: ['slider-select.component.scss']
})
export class SliderSelectComponent implements OnInit {

  @Input() public heading;
  @Input() public rangeArray;
  @Output() public sliderChange: EventEmitter<any> = new EventEmitter();

  defaultVal: any = 0
  constructor(private actions$: Actions) {
  }

  ngOnInit() {
    this.actions$
      .pipe(ofType(EGetAlertsActions.GetAlertsSuccess))
      .subscribe(() => {
        this.defaultVal = 0
      });
  }
}
